import client from './client';

export const getContractList = ({ page, sort, sortType, search }) =>
  client.get(
    `/contract?page=${page}&limit=10&sort=${sort}&sortType=${sortType}&search=${search}`,
  );

export const getContract = id => client.get(`/contract/${id}`);

export const createContract = ({
  contract: { company, code, termStartDate, termEndDate, name, tel, detail },
  store,
  user: {
    userId,
    password,
    name: username,
    team,
    position,
    tel: userTel,
    email,
  },
}) =>
  client.post('/contract', {
    contract: {
      company,
      code,
      termStartDate,
      termEndDate,
      name,
      tel,
      detail,
    },
    store /*[{name: string, address: string, detailAddress}]*/,
    user: {
      userId,
      password,
      name: username,
      team,
      position,
      tel: userTel,
      email,
    },
  });

export const deleteContract = id =>
  client.post(`/contract/${id}`, null, {
    headers: {
      'X-Method-Override': 'DELETE',
    },
  });

export const updateContract = ({
  id,
  contract: { company, code, termStartDate, termEndDate, name, tel, detail },
  updateStore /* [{id: Int, name: String, address: String, detailAddress: String}] */,
  insertStore /* [{name: String, address: String, detailAddress: String }] */,
  user: {
    id: masterId,
    userId,
    name: username,
    team,
    tel: userTel,
    position,
    email,
  },
}) =>
  client.post(
    `/contract/${id}`,
    {
      contract: {
        company,
        code,
        termStartDate,
        termEndDate,
        name,
        tel,
        detail,
      },
      updateStore,
      insertStore,
      user: {
        id: masterId,
        userId,
        name: username,
        team,
        tel: userTel,
        position,
        email,
      },
    },
    {
      headers: {
        'X-Method-Override': 'PUT',
      },
    },
  );

export const createMasterKids = ({
  masterId,
  masterKids: { userId, password },
}) =>
  client.post('/user/kids', {
    masterId,
    masterKids: {
      userId,
      password,
    },
  });

export const deleteMasterKid = id =>
  client.post(`/user/kids/${id}`, null, {
    headers: {
      'X-Method-Override': 'DELETE',
    },
  });

export const updateMasterKidPassword = id =>
  client.post(`/user/kids/${id}/password`, null, {
    headers: {
      'X-Method-Override': 'PATCH',
    },
  });
